import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';

class AutoResizeTextarea extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
					formData: props.formData,
				};
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps);
    }

	onChange() {
		return (event) => {
			this.setState({
				formData: event.target.value
			}, () => this.props.onChange(this.state.formData));
		};
	}

	render() {
		return (
			<div>
				<label className="control-label">{this.props.schema.title}</label>
				<TextareaAutosize onChange={this.onChange()} className="form-control" rows={3}
								  value={this.state.formData || ''} required={this.props.required}/>
			</div>
		);
	}
}

export default AutoResizeTextarea;